import {
    Component
} from '@angular/core';

import {
    Platform
} from '@ionic/angular';
import {
    SplashScreen
} from '@ionic-native/splash-screen/ngx';
import {
    StatusBar
} from '@ionic-native/status-bar/ngx';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent {
    public appPages = [{
        title: 'Welcome',
        url: '/home',
        icon: 'home'
    },
    {
        title: 'Video',
        url: '/video',
        icon: 'videocam'
    },
    {
        title: 'Wedding Events',
        url: '/events',
        icon: 'wine'
    },
    {
        title: 'Travel & Parking',
        url: '/travel',
        icon: 'bus'
    },
    {
        title: 'Experience Miami!',
        url: '/miami',
        icon: 'megaphone'
    },
    {
        title: 'Registry',
        url: '/registry',
        icon: 'list'
    },
    {
        title: 'Guests',
        url: '/guests',
        icon: 'people'
    },
    {
        title: 'About',
        url: '/about',
        icon: 'information'
    },
    {
        title: 'Music',
        url: '/music',
        icon: 'musical-note'
    }
    ];

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar
    ) {
        this.initializeApp();
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }
}
